import React,{ useState,useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MDBDataTable } from 'mdbreact';
import Tooltip from '../../common/toolTip';
import ReviewStatusAdd from './add';
import ReviewStatusDelete from './delete';
import axios from 'axios';
import { baseUrl } from '../../../api/common';
const ReviewStatus = () => {

    const [addPopupStatus, setAddPopupStatus] = useState(false);

    const [updateData, setUpdateData] = useState({});

    const [eventType, setEventType] = useState('');

    const handleAddPopup = (status,type,data) => {
        setUpdateData(data);
        setEventType(type);
        setAddPopupStatus(status);
        setViewPopupStatus(false);   
    };

    const [viewPopupStatus, setViewPopupStatus] = useState(false);
    
    const handleViewPopup = (type,data) => {
        setUpdateData(data);
        setEventType(type);
        setViewPopupStatus(true);
    };

    const [deletePopupStatus, setDeletePopupStatus] = useState(false);
    const [deleteId, setDeleteId] = useState();
    const handleDelete = (id) => {
      setDeleteId(id);
      setDeletePopupStatus(true);
    };

    const handleCloseDelete = () => {
        setDeletePopupStatus(false);
        setViewPopupStatus(false);
    };
    const [reviewStatusData, setReviewStatusData] = useState([]);

    const fetchReviewStatusData = async () => {
        try {
          const response = await axios.get(
            `${baseUrl}/api/get_review_status`,   
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: localStorage.getItem('access_token'),
              },
            }
          );
    
          if (response.data.status) {          
            setReviewStatusData(response.data.data);
          } else {
            console.error('Error: Failed to fetch user data');
          }
        } catch (error) {
          console.error('Error fetching users data:', error);
        }
    };

    const body = {
        columns: [
            {
                label: 'S.No',
                field: 'sno',
                attributes: {
                    style: { width: '50%', fontWeight: 'bold' },
                },
            },
            {
                label: 'Review Status',
                field: 'status',
                width: 150,
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Name',
                    style: { width: '50%', fontWeight: 'bold' },
                },
            },
            {
                label: 'Action',
                field: 'action',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Action',
                    style: { width: '1%', fontWeight: 'bold' },
                },
            }
        ],
        rows:reviewStatusData&&reviewStatusData.map((data, index) => ({
            sno: index + 1,
            status: data.review_status_name || "N/A",
            action: (
                <div>
                  <Tooltip text="Update" id="update" />
                  <button 
                    type="button" 
                    onClick={(e) => { e.stopPropagation(); handleAddPopup(true, "Update", data); }}
                    className="btn btn-sm btn-default" 
                    title="Edit"
                    data-for="update" 
                    data-tip
                  >
                    <i className="fa fa-edit"></i>
                  </button>
                  <Tooltip text="Delete" id="delete" />
                  <button 
                    type="button" 
                    onClick={(e) => { e.stopPropagation(); handleDelete(data.id); }} 
                    className="btn btn-sm btn-default" 
                    title="Delete"
                    data-for="delete" 
                    data-tip
                  >
                    <i className="fa fa-trash"></i>
                  </button>
                </div>
            ),  
            clickEvent: () => handleViewPopup("Update",data),
        }))
    }

    useEffect(() => {
      fetchReviewStatusData();
    }, []); 

    return (
        <>
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h1>Review Status Master </h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/">Amasi</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Review Status Master</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right hidden-xs">
                            <span onClick={() => handleAddPopup(true,"Add",{})} className="btn btn-outline-primary mr-1" title="">Add New</span>
                        </div>
                    </div>
                </div>
                <div className="row clearfix">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="body">
                                <div className="table-responsive">
                                    <MDBDataTable
                                        noBottomColumns
                                        className="table table-hover js-basic-example dataTable table-custom spacing5"
                                        entriesOptions={[10, 25, 50, 100]}
                                        entries={25}
                                        paging
                                        pagesAmount={3}
                                        data={body}
                                        sortRows={['title']}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ReviewStatusAdd 
                    fetchReviewStatusData={fetchReviewStatusData} 
                    addPopupStatus={addPopupStatus} 
                    handleAddPopup={handleAddPopup}
                    eventType={eventType} 
                    updateData={updateData}
                />

                <ReviewStatusDelete
                    fetchReviewStatusData={fetchReviewStatusData} 
                    deletePopupStatus={deletePopupStatus}
                    handleCloseDelete={handleCloseDelete}
                    deleteId={deleteId}
                />

                {updateData&& <div className={`extraspace_search_div search_div${viewPopupStatus ? " open" : ""}`}>
                    <div className="card member_master_sidebar_scrool">
                        <div className="member_edit_pop_flex mb-3 text-end">
                            <h3>View Review Status</h3>
                            <div className="input-group-append d-flex gap-10">
                                <div>
                                    <button onClick={()=>handleDelete(updateData.id)} class="saveand_proced_button btn btn btn-outline-danger btn-block" type="button"><i class="icon-trash"></i> Delete </button>
                                </div>
                                <div>
                                    <button onClick={()=> handleAddPopup(true,"Update",updateData)} class="saveand_proced_button btn btn-outline-info btn-block" type="button"><i class="fa fa-edit"></i> Edit </button>
                                </div>
                                <span onClick={() => setViewPopupStatus(false)} className="search_toggle btn btn-danger"><i className="fa fa-times"></i></span>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <div className="body application_body_side">
                                <fieldset>
                                    <div className="row clearfix">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="body">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <small className="text-muted"><b>Review Status</b> </small>
                                                            <p>{updateData.review_status_name}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>}

            </div>
        </>

    );

}
export default ReviewStatus
